import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "3", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "6", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "18", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 9a9 9 0 0 1-9 9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GitBranch";
const GitBranch = memo(themed(Icon));
export {
  GitBranch
};
//# sourceMappingURL=git-branch.js.map
